// extracted by mini-css-extract-plugin
export default {"component-details-tab":"ComponentDetailsTab_component-details-tab__SGgPl","flag-icon":"ComponentDetailsTab_flag-icon__xL9ul","globe-icon":"ComponentDetailsTab_globe-icon__yZIvQ"};